import { render, staticRenderFns } from "./QueclinkTrackerStatisticsLiveBlock.vue?vue&type=template&id=0bcbb37b&scoped=true"
import script from "./QueclinkTrackerStatisticsLiveBlock.vue?vue&type=script&lang=js"
export * from "./QueclinkTrackerStatisticsLiveBlock.vue?vue&type=script&lang=js"
import style0 from "./QueclinkTrackerStatisticsLiveBlock.vue?vue&type=style&index=0&id=0bcbb37b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcbb37b",
  null
  
)

export default component.exports